import { createHttpClient } from './httpClient';

export function createSoulodyClient({ baseURL, ensureValidToken, getAccessToken }) {
  function soulodyTokenMiddleware(next) {
    return async (url, init = {}) => {
      const urlStr = typeof url === 'string' ? url : url.toString();

      if (urlStr === 'token' || urlStr.endsWith('/token')) {
        return next(url, init);
      }

      if (!init.skipSoulodyTokenEnsure) {
        const hasToken = await ensureValidToken();
        if (!hasToken) {
          throw new Error('Missing soulodyApi token');
        }
      }

      const token = getAccessToken();
      if (!token) {
        throw new Error('Missing soulodyApi token');
      }

      const headers = { ...(init.headers || {}), Authorization: `Bearer ${token}` };
      return next(url, { ...init, headers });
    };
  }

  return createHttpClient({
    baseURL,
    headers: { 'Content-Type': 'application/json' },
    middleware: [soulodyTokenMiddleware]
  });
}
